import { useSyncExternalStore } from 'react';

import { secondTicker as second } from '../../../../utilities/customHooks/secondTicker';

const idle = (): (() => void) => () => undefined;

export const useDeadlinePassed = (at: number | null): boolean => {
  const read = (): boolean => at === null || second.getSnapshot() >= at;
  const subscribe = read() ? idle : second.subscribe;
  return useSyncExternalStore(subscribe, read, read);
};
